//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectFace.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectEdge.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"BendFace",0,"SelectFace",0],[1,"CornerRadius",0,"Expression",0],[0,"DatumPlane",1,"Plane",0],[1,"Depth",0,"Expression",0],[1,"DieRadius",0,"Expression",0],[0,"PlacementCount",1,0],[1,"PlacementDistance",0,"Expression",0],[1,"PlacementSpacing",0,"Expression",0],[0,"PlacementType",1,0],[1,"PunchRadius",0,"Expression",0],[1,"Section",0,"Section",0],[0,"Shape",1,0],[1,"SideAngle",0,"Expression",0],[1,"StartEdge",0,"SelectEdge",0],[0,"Type",1,0],[1,"Width",0,"Expression",0],[0,"WidthSide",1,0]],[[["nCandidateEdges","candidateEdges"],"GetStartEdgeCandidates",{},0,0],[["origin"],"GetPlacementOriginAndDirection",{R_:{direction:''}},0,0],[[],"AlternateSolution",{},0,0],[[],"GetIsPreNx10",{R_:{isPreNX10:''}},0,0]],[]];
SPLM.Features.SheetMetal.GussetBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.GussetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.GussetBuilder.Types = Object.freeze({
    "AutomaticProfile" : "AutomaticProfile", "UserDefinedProfile" : "UserDefinedProfile"});

SPLM.Features.SheetMetal.GussetBuilder.WidthSides = Object.freeze({
    "Side1" : "Side1", "Side2" : "Side2", "Symmetric" : "Symmetric"});

SPLM.Features.SheetMetal.GussetBuilder.PlacementTypes = Object.freeze({
    "Single" : "Single", "Fit" : "Fit", "Fill" : "Fill", "Fixed" : "Fixed"});

SPLM.Features.SheetMetal.GussetBuilder.Shapes = Object.freeze({
    "Square" : "Square", "Round" : "Round"});

export default SPLM;